import React from 'react';

const fNum  = v => (v == null ? '-' : Math.round(Number(v)).toLocaleString('ko-KR'));
const fCard = v => {
  if (v == null) return '-';
  const sign = v < 0 ? '-' : '';
  const n = Math.abs(v);
  if (n >= 1e8) return `${sign}${(n / 1e8).toFixed(1)}억`;
  if (n >= 1e4) return `${sign}${Math.round(n / 1e4)}만`;
  return `${sign}${Math.round(n).toLocaleString('ko-KR')}`;
};

const colorCls = v => (Number(v) > 0 ? 'pos' : Number(v) < 0 ? 'neg' : '');

export default function MetricCard({
  label,      // string
  value,      // number|null
  unit,       // string (기본 '원', '%'로 override 가능)
  signed,     // bool — 양수에 + 부호 추가
  decimals,   // number — 소수 자릿수 (수익률 등)
  sub,        // string — 보조 텍스트
}) {
  const v = value ?? null;
  const u = unit ?? '원';
  const isColored = signed && v != null;
  const cls = isColored ? colorCls(v) : '';

  const displayValue = v == null
    ? '-'
    : decimals != null
      ? `${signed && v > 0 ? '+' : ''}${Number(v).toFixed(decimals)}${u}`
      : `${signed && v > 0 ? '+' : ''}${fCard(v)}${u === '%' ? '%' : '원'}`;

  const showExact = v != null && Math.abs(v) >= 10000 && u !== '%' && decimals == null;

  return (
    <div className="mb-metric-card">
      <div className="mb-metric-label">{label}</div>
      <div className={`mb-metric-value${cls ? ` ${cls}` : ''}`}>{displayValue}</div>
      {sub && <div className="mb-metric-sub">{sub}</div>}
      {showExact && <div className="mb-metric-exact">{signed && v > 0 ? '+' : ''}{fNum(v)}원</div>}
    </div>
  );
}
